export const createMessenger = (win: Window) => (target: Window, action: string, args: string[]) => {
    target.postMessage({ action, args, source: 'Vibes' }, win.origin);
};

// Create the messenger once so we don't have to pull Window into scope in several locations
export default createMessenger(window);